import { Separator } from "@/components/ui/separator";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { SidebarNav } from "./sidebar";

interface MobileSidebarProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ownerId?: string | null;
}

export function MobileSidebar({ open, onOpenChange, ownerId }: MobileSidebarProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-72 p-0 bg-sidebar text-sidebar-foreground">
        <SheetHeader className="px-6 py-4">
          <SheetTitle className="font-serif text-lg text-white tracking-tight">
            Faithful Platform
          </SheetTitle>
        </SheetHeader>
        <Separator className="bg-white/10" />
        <SidebarNav onNavigate={() => onOpenChange(false)} ownerId={ownerId} />
      </SheetContent>
    </Sheet>
  );
}
